import { render } from "./ImportGroupDialog.vue?vue&type=template&id=b2a4f7c6"
import script from "./js/importGroupDialog.js?vue&type=script&lang=js&external"
export * from "./js/importGroupDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__